import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {
    Button,
    CircularProgress,
    Grid,
    Input,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    LinearProgress,
    List,
    ListItem,
    ListItemText, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Tooltip
} from "@material-ui/core";
import ReactTable from "react-table";
import AdminService from "../../../services/AdminService";
import {
    MoreHoriz,
    Done,
    Clear,
    PersonAddDisabled,
    PermIdentity,
    Email,
    MobileFriendly, Edit, HighlightOff, Save
} from "@material-ui/icons";

const adminService = new AdminService();

const styles = theme => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
    },
    table: {
        minWidth: "auto",
        tableLayout: "auto"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default,
        },
    },
    done: {
        color: "#38ff6e"
    },
    clear: {
        color: "#ff6269",
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit,
        fontSize: 10
    },
    rightIcon: {
        //marginLeft: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
    },
    input: {
        fontSize: 14
    },
});

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: "#5571ff",
        color: theme.palette.common.white,
    }
}))(TableCell);

const requestData = (pageSize, page, sorted, filtered) => {
    return new Promise((resolve, reject) => {
        adminService.allUsers({
            pageSize: pageSize,
            page: page,
            sorted: sorted,
            filtered: filtered
        }, (err, data) => {
            if (err) {
                const res = {
                    rows: [],
                    pages: 0
                };
                return resolve(res);
            } else {
                let filteredData = data.results;
                const res = {
                    rows: filteredData,
                    pages: data.pages
                };
                return resolve(res);
            }
        });
    });
};

class userTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pages: null,
            loading: true,
            loadings: true,
            imgLoading: false,
            success: false,
            open: false,
            fullWidth: true,
            maxWidth: "md",
            isAttrEdit: true
        };
        this.signUpData = {};
        this.fetchData = this.fetchData.bind(this);
        this.changeState = this.changeState.bind(this);
        this._onChange = this._onChange.bind(this);
    }

    fetchData(state, instance) {
        this.setState({loading: true});
        //console.debug(state);
        requestData(
            state.pageSize,
            state.page,
            state.sorted,
            state.filtered,
        ).then(res => {
            this.setState({
                data: res.rows,
                pages: res.pages,
                loading: false
            });
        });
    }

    handleClickOpen = param => e => {
        this.props.getUserById(param);
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
        this.refReactTable.fireFetchData();
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    changeState = (id, option) => {
        console.debug("user stat:", id + "-" + option);
        this.props.userStateChange(id, option);
    };

    changeAttribute = (id, attrName, attrValue) => {

        let attList = [
            {
                "Name": attrName,
                "Value": attrValue
            }
        ];

        this.props.userAttributeChange(id, attList);
    };

    attrChange = (state) => {
        this.setState({isAttrEdit: state});
    };

    _onChange(e) {
        console.log(this.signUpData);
        this.signUpData[e.target.name] = e.target.value;
    }

    editUserAttribute = (id) => {

        let data = this.signUpData;
        let userAttArr = [];

        for (var keyName in data) {
            userAttArr.push({
                "Name": keyName,
                "Value": data[keyName]
            });
        }

        this.setState({isAttrEdit: true});
        this.props.userAttributeChange(id, userAttArr);
        this.signUpData = [];
    };

    cancelUserAttribute = (id) => {
        this.signUpData = [];
        this.setState({isAttrEdit: true});
        this.props.getUserById(id);
    };


    render() {
        const {classes, fullScreen} = this.props;
        const {isAttrEdit} = this.state;
        const {isLoading, userCreateDate, userLastModifiedDate, enabled, userAttributes, isUserExist, groups, isEditing} = this.props.userMgt;

        //console.debug(this.props);

        const columns = [
            {
                Header: "First Name",
                accessor: "firstName",
                style: {textAlign: "center"},
                Filter: ({filter, onChange}) => {
                    return (
                        <Input
                            onKeyPress={event => {
                                if (event.keyCode === 13 || event.which === 13) {
                                    onChange(event.target.value);
                                }
                            }}
                        />
                    );
                },
            },
            {
                Header: "Last Name",
                accessor: "lastName",
                style: {textAlign: "center"},
                Filter: ({filter, onChange}) => {
                    return (
                        <Input
                            onKeyPress={event => {
                                if (event.keyCode === 13 || event.which === 13) {
                                    onChange(event.target.value);
                                }
                            }}
                        />
                    );
                },
            },
            {
                Header: "Email",
                accessor: "email",
                style: {textAlign: "center"},
                Filter: ({filter, onChange}) => {
                    return (
                        <Input
                            onKeyPress={event => {
                                if (event.keyCode === 13 || event.which === 13) {
                                    onChange(event.target.value);
                                }
                            }}
                        />
                    );
                },
            },
            {
                Header: "NIC",
                accessor: "nic",
                style: {textAlign: "center"},
                Filter: ({filter, onChange}) => {
                    return (
                        <Input
                            onKeyPress={event => {
                                if (event.keyCode === 13 || event.which === 13) {
                                    onChange(event.target.value);
                                }
                            }}
                        />
                    );
                },
            },
            {
                Header: "Mobile #",
                accessor: "phoneNumber",
                style: {textAlign: "center"},
                Filter: ({filter, onChange}) => {
                    return (
                        <Input
                            onKeyPress={event => {
                                if (event.keyCode === 13 || event.which === 13) {
                                    onChange(event.target.value);
                                }
                            }}
                        />
                    );
                },
            },
            {
                Header: "Wallet",
                accessor: "wallet",
                style: {textAlign: "center"},
                Filter: ({filter, onChange}) => {
                    return (
                        <Input
                            onKeyPress={event => {
                                if (event.keyCode === 13 || event.which === 13) {
                                    onChange(event.target.value);
                                }
                            }}
                        />
                    );
                },
            },
            {
                Header: "Date",
                accessor: "createdAt",
                style: {textAlign: "center"},
                Filter: ({filter, onChange}) => {
                    return (
                        <Input
                            onKeyPress={event => {
                                if (event.keyCode === 13 || event.which === 13) {
                                    onChange(event.target.value);
                                }
                            }}
                        />
                    );
                },
            },
            {
                Header: "Action",
                accessor: "userId",
                style: {textAlign: "center"},
                Cell: row => (
                    <Button variant="outlined" color="primary" size="small" onClick={this.handleClickOpen(row.value)}>
                        <MoreHoriz/>
                    </Button>
                )
            }

        ];

        return (
            <div>
                <ReactTable
                    columns={columns}
                    className="-striped -highlight"
                    data={this.state.data}
                    loading={this.state.loading}
                    pages={this.state.pages}
                    defaultPageSize={10}
                    manual
                    filterable
                    onFetchData={this.fetchData}
                    showPageJump={false}
                    loadingText={<CircularProgress size={30} thickness={5}/>}
                    noDataText={"No Users available"}
                    style={{
                        height: "500px" 
                    }}
                    defaultSorted={[
                        {
                            id: "createdAt",
                            desc: true

                        }
                    ]}
                    ref={(refReactTable) => {
                        this.refReactTable = refReactTable;
                    }}
                />

                <div style={{flexGrow: 1}}>
                    <Dialog
                        fullScreen={fullScreen}
                        open={this.state.open}
                        onClose={this.handleClose}
                        maxWidth='xl'
                        aria-labelledby="responsive-dialog-title"
                    >
                        {isEditing ? <LinearProgress/> : null}
                        <DialogTitle id="responsive-dialog-title">{"Customization"}</DialogTitle>
                        <DialogContent>

                            {isUserExist ?
                                <Grid
                                    container
                                    direction="row"
                                    justify="flex-end"
                                    alignItems="flex-start"
                                    spacing={0}
                                >

                                    {/*<Grid item>*/}
                                    {/*{isLoading ?*/}
                                    {/*null*/}
                                    {/*:*/}
                                    {/*<Button variant="outlined" color="primary" className={classes.button}>*/}
                                    {/*Group Manage*/}
                                    {/*<Group className={classes.rightIcon}/>*/}
                                    {/*</Button>*/}
                                    {/*}*/}
                                    {/*</Grid>*/}

                                    <Grid item>
                                        {isLoading ? null : enabled ?
                                            <Tooltip title="Disable user" placement="top">
                                                <Button variant="outlined" color="secondary" className={classes.button}
                                                    disabled={!!isEditing}
                                                    onClick={() => {
                                                        this.changeState(userAttributes.sub, 0);
                                                    }}
                                                >
                                                    <PersonAddDisabled className={classes.rightIcon}/>
                                                </Button>
                                            </Tooltip>
                                            :
                                            <Tooltip title="Enable user" placement="top">
                                                <Button variant="outlined" color="primary" className={classes.button}
                                                    disabled={!!isEditing}
                                                    onClick={() => {
                                                        this.changeState(userAttributes.sub, 1);
                                                    }}
                                                >
                                                    <PermIdentity className={classes.rightIcon}/>
                                                </Button>
                                            </Tooltip>
                                        }
                                    </Grid>

                                    <Grid item>
                                        {isLoading ? null : userAttributes.email_verified !== "true" ?
                                            <Tooltip title="Verify Email" placement="top">
                                                <Button variant="outlined" color="secondary" className={classes.button}
                                                    disabled={!!isEditing}
                                                    onClick={() => {
                                                        this.changeAttribute(userAttributes.sub, "email_verified", "true");
                                                    }}
                                                >
                                                    <Email className={classes.rightIcon}/>
                                                </Button>
                                            </Tooltip>
                                            :
                                            null
                                        }
                                    </Grid>

                                    <Grid item>
                                        {isLoading ? null : userAttributes.phone_number_verified !== "true" ?
                                            <Tooltip title="Verify Mobile No" placement="top">
                                                <Button variant="outlined" color="secondary" className={classes.button}
                                                    disabled={!!isEditing}
                                                    onClick={() => {
                                                        this.changeAttribute(userAttributes.sub, "phone_number_verified", "true");
                                                    }}
                                                >
                                                    <MobileFriendly className={classes.rightIcon}/>
                                                </Button>
                                            </Tooltip>
                                            :
                                            null
                                        }
                                    </Grid>

                                </Grid>
                                :
                                null
                            }


                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <CustomTableCell>Scope</CustomTableCell>
                                        <CustomTableCell>Groups</CustomTableCell>
                                        <CustomTableCell>Enabled</CustomTableCell>
                                        <CustomTableCell>Email Verified</CustomTableCell>
                                        <CustomTableCell>Phone Number Verified</CustomTableCell>
                                        <CustomTableCell>Register Date</CustomTableCell>
                                        <CustomTableCell>Last Modified Date</CustomTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow className={classes.row}>
                                        <TableCell align="center">{
                                            isLoading ? <LinearProgress/> : userAttributes["custom:scope"]}
                                        </TableCell>
                                        <TableCell align="center">{
                                            isLoading ? <LinearProgress/> : groups ?
                                                <List dense={true}>
                                                    {
                                                        groups.map(item => (
                                                            <ListItem key={item} style={{margin: 0}}>
                                                                <ListItemText
                                                                    primary={item}
                                                                />
                                                            </ListItem>
                                                        ))
                                                    }
                                                </List>
                                                :
                                                "-"
                                        }
                                        </TableCell>
                                        <TableCell align="center">{
                                            isLoading ? <LinearProgress/> : enabled ? <Done className={classes.done}/> :
                                                <Clear className={classes.clear}/>}
                                        </TableCell>
                                        <TableCell align="center">{
                                            isLoading ? <LinearProgress/> : userAttributes.email_verified === "true" ?
                                                <Done className={classes.done}/> :
                                                <Clear className={classes.clear}/>}
                                        </TableCell>
                                        <TableCell align="center">
                                            {isLoading ?
                                                <LinearProgress/> : userAttributes.phone_number_verified === "true" ?
                                                    <Done className={classes.done}/> :
                                                    <Clear className={classes.clear}/>}
                                        </TableCell>
                                        <TableCell align="center">
                                            {isLoading ? <LinearProgress/> : userCreateDate}
                                        </TableCell>
                                        <TableCell align="center">
                                            {isLoading ? <LinearProgress/> : userLastModifiedDate}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>

                            <Table className={classes.table} fixedHeader={false}>
                                <TableHead>
                                    <TableRow>
                                        <CustomTableCell></CustomTableCell>
                                        <CustomTableCell>Last Name</CustomTableCell>
                                        <CustomTableCell>First Name</CustomTableCell>
                                        <CustomTableCell>Email</CustomTableCell>
                                        <CustomTableCell>NIC</CustomTableCell>
                                        <CustomTableCell>Phone number</CustomTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow className={classes.row}>
                                        <TableCell>{
                                            isLoading ? <LinearProgress/> :
                                                <div>
                                                    {isAttrEdit ?
                                                        <Tooltip title="Edit" placement="right">
                                                            <IconButton aria-label="Edit"
                                                                onClick={() => {
                                                                    this.attrChange(false);
                                                                }}
                                                                disabled={!!isEditing}>
                                                                <Edit fontSize="small"/>
                                                            </IconButton>
                                                        </Tooltip>
                                                        :
                                                        <div>
                                                            <Tooltip title="Save" placement="right">
                                                                <IconButton aria-label="Edit"
                                                                    onClick={() => {
                                                                        this.editUserAttribute(userAttributes.sub);
                                                                    }}
                                                                    disabled={!!isEditing}>
                                                                    <Save fontSize="small"/>
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Cancel" placement="right">
                                                                <IconButton aria-label="Edit"
                                                                    onClick={() => {
                                                                        this.cancelUserAttribute(userAttributes.sub);
                                                                    }}
                                                                    disabled={!!isEditing}>
                                                                    <HighlightOff fontSize="small"/>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>

                                                    }

                                                </div>
                                        }
                                        </TableCell>
                                        <TableCell>{
                                            isLoading ? <LinearProgress/> :

                                                <Input
                                                    defaultValue={userAttributes.family_name}
                                                    disabled={isAttrEdit}
                                                    name="family_name"
                                                    className={classes.input}
                                                    onChange={this._onChange}
                                                    inputProps={{
                                                        "aria-label": "Description",
                                                    }}
                                                />
                                        }
                                        </TableCell>
                                        <TableCell>{
                                            isLoading ? <LinearProgress/> :
                                                <Input
                                                    defaultValue={userAttributes.given_name}
                                                    disabled={isAttrEdit}
                                                    className={classes.input}
                                                    name="given_name"
                                                    onChange={this._onChange}
                                                    inputProps={{
                                                        "aria-label": "Description",
                                                    }}
                                                />
                                        }
                                        </TableCell>
                                        <TableCell>{
                                            isLoading ? <LinearProgress/> :
                                                <Input
                                                    defaultValue={userAttributes.email}
                                                    disabled={isAttrEdit}
                                                    className={classes.input}
                                                    name="email"
                                                    onChange={this._onChange}
                                                    inputProps={{
                                                        "aria-label": "Description",
                                                    }}
                                                />
                                        }
                                        </TableCell>
                                        <TableCell>{
                                            isLoading ? <LinearProgress/> :
                                                <Input
                                                    defaultValue={userAttributes["custom:nic"]}
                                                    disabled={isAttrEdit}
                                                    className={classes.input}
                                                    name="custom:nic"
                                                    onChange={this._onChange}
                                                    inputProps={{
                                                        "aria-label": "Description",
                                                    }}
                                                />
                                        }
                                        </TableCell>
                                        <TableCell>{
                                            isLoading ? <LinearProgress/> :
                                                <Input
                                                    defaultValue={userAttributes.phone_number}
                                                    disabled={isAttrEdit}
                                                    className={classes.input}
                                                    name="phone_number"
                                                    onChange={this._onChange}
                                                    inputProps={{
                                                        "aria-label": "Description",
                                                    }}
                                                />
                                        }
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary" variant="outlined">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>

            </div>
        );
    }
}

userTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(userTable);
